/**
 * Unread-badge event bus.
 *
 * Any component that polls an unread/unseen counter should call
 * `subscribeUnreadRefresh(fn)` in its effect and unsubscribe on cleanup.
 * Any component that KNOWS a user action just changed unread state
 * (e.g. opening a ticket, marking messages as read) should call
 * `triggerUnreadRefresh()` — this fires an instant refetch across
 * every subscribed counter in the app, without waiting for the next
 * polling cycle.
 *
 * This is a lightweight abstraction over `window` events so the app
 * doesn't need an extra state library for cross-tree communication.
 */
const EVENT_NAME = 'app:unread:refresh';

export const triggerUnreadRefresh = () => {
  try {
    window.dispatchEvent(new Event(EVENT_NAME));
  } catch {
    /* SSR-safe: window may be undefined in tests */
  }
};

export const subscribeUnreadRefresh = (handler) => {
  if (typeof window === 'undefined' || !handler) return () => {};
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
};
